import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../data.service';

interface TabConfig {
  label: string;
  encuestaId: string;
  formularioId: string;
}

@Component({
  selector: 'app-pppfa',
  templateUrl: './pppfa.component.html',
  styleUrls: ['./pppfa.component.css']
})
export class PppfaComponent implements OnInit {
  items: MenuItem[] = [];
  activeItem: MenuItem;

  readonly tabs: TabConfig[] = [
    {
      label: 'Patrocinadores',
      encuestaId: '692e0e3650e0fc117615ae31',
      formularioId: '692e0d816a9973b5ba35abde'
    },
    {
      label: 'Programas',
      encuestaId: '692e3c68b275b4b3bf746eea',
      formularioId: '692e36918b21ea11beee8fa8'
    },
    {
      label: 'Promociones',
      encuestaId: '692ececcb899a66ff14b8d66',
      formularioId: '692ecb4e771a58f87aed817f'
    },
    {
      label: 'Formularios',
      encuestaId: '692ececcb899a66ff14b8d66',
      formularioId: '692ecb4e771a58f87aed817f'
    },
    {
      label: 'Solicitudes',
      encuestaId: '692ececcb899a66ff14b8d66',
      formularioId: '692ecb4e771a58f87aed817f'
    }
  ];

  encuestaIdSeleccionada = this.tabs[0].encuestaId;
  formularioIdSeleccionado = this.tabs[0].formularioId;

  // Variables para filtro de Programas
  patrocinadores: any[] = [];
  patrocinadorSeleccionado: any = null;
  filtroProgramas: { campo: string, valor: any }[] = [];

  // Variables para filtro de Promociones (lista de programas filtrados)
  programas: any[] = [];
  programaSeleccionado: any = null;
  filtroPromociones: { campo: string, valor: any }[] = [];

  // Variables para Formulario (promociones)
  promociones: any[] = [];
  promocionSeleccionada: any = null;

  // Referencia estable para "sin filtros" y evitar disparar detecciones innecesarias
  filtroVacio: any[] = [];

  private toNumberIfPossible(valor: any) {
    const num = Number(valor);
    return isNaN(num) ? valor : num;
  }

  constructor(private data: DataService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.items = this.tabs.map(p => ({ label: p.label }));
    
    // Suscribirse a cambios en query params para reaccionar a navegación interna
    this.route.queryParams.subscribe(params => {
      const tabParam = params['tab'];
      const patrocinadorParam = params['patrocinador'];
      const programaParam = params['programa'];
      const promocionParam = params['promocion'];

      // Seleccionar pestaña activa
      let tabIndex = 0;
      if (tabParam) {
        const idx = this.items.findIndex(i => i.label?.toLowerCase() === tabParam.toLowerCase());
        if (idx !== -1) tabIndex = idx;
      }
      
      this.activeItem = this.items[tabIndex];
      this.actualizarConfiguracionPestana(this.activeItem);

      // Si tenemos patrocinador, cargamos flujo normal (Patrocinador -> Programas)
      if (patrocinadorParam) {
        this.cargarPatrocinadores(patrocinadorParam, programaParam);
      } else if (promocionParam) {
        // Si llega promocion, deduce programa y patrocinador a partir de ella
        this.cargarPromocionDesdeParametro(promocionParam);
      }
      // Si NO tenemos patrocinador pero SÍ programa, deducimos el patrocinador desde el programa
      else if (programaParam) {
        this.cargarPatrocinadorDesdePrograma(programaParam);
      }
      // Si no hay nada, carga lista base de patrocinadores
      else {
        this.cargarPatrocinadores();
      }
    });
  }

  cargarPatrocinadorDesdePrograma(progCodigo: string) {
    // Caso especial: Cargar programa específico SIN filtro de patrocinador para descubrirlo
    this.cargarProgramas(null, progCodigo);
  }

  cargarPatrocinadores(patrocinadorPreseleccionado: string | null = null, programaPreseleccionado: string | null = null) {
    // Encuesta de Patrocinadores
    const idEncuestaPatrocinadores = '692e0e3650e0fc117615ae31';
    
    // Solicitamos campos específicos, asegurando enviar array vacío en filtros para mantener firma
    this.data.ObtenerRegistros(idEncuestaPatrocinadores, ['patCodigo', 'patNombreCorto', 'patNombre'], 1, 1000, 0, []).subscribe({
      next: (res) => {
        if (res.registros) {
          this.patrocinadores = res.registros.map((r: any) => ({
             label: `${r['patNombre'] || ''} - ${r['patNombreCorto'] || ''}`,
             value: r['patCodigo']
          })).filter(p => p.value); // Filtra los que no tengan patCodigo

          // Si hay parametro de patrocinador, lo seleccionamos
          if (patrocinadorPreseleccionado) {
             // Convertir a número si patCodigo es numérico
             const valorNumerico = Number(patrocinadorPreseleccionado);
             this.patrocinadorSeleccionado = isNaN(valorNumerico) ? patrocinadorPreseleccionado : valorNumerico;
             this.onPatrocinadorChange({ value: this.patrocinadorSeleccionado });
             
             // Si tambien hay programa preseleccionado
             if (programaPreseleccionado) {
                this.cargarProgramas(this.patrocinadorSeleccionado, programaPreseleccionado);
             }
          }
        }
      },
      error: (err) => console.error('Error cargando patrocinadores', err)
    });
  }

  onPatrocinadorChange(event: any) {
    const valorOriginal = event.value;
    const valorFinal = this.toNumberIfPossible(
      valorOriginal != null ? String(valorOriginal).trim() : valorOriginal
    );

    if (valorFinal) {
      this.filtroProgramas = [{ campo: 'pliPatrocinador_patCodigo', valor: valorFinal }];
      // Fuerza nueva referencia para disparar OnChanges en el hijo
      this.filtroProgramas = [...this.filtroProgramas];

      // Al cambiar patrocinador, limpiar selección de programa y su filtro
      this.programaSeleccionado = null;
      this.filtroPromociones = [];
      this.filtroPromociones = [...this.filtroPromociones];

      // Al seleccionar patrocinador, cargar sus programas para el filtro de promociones
      this.cargarProgramas(valorFinal);
    } else {
      this.filtroProgramas = [];
      this.filtroProgramas = [...this.filtroProgramas];

      this.programas = [];
      this.programaSeleccionado = null;

      this.filtroPromociones = [];
      this.filtroPromociones = [...this.filtroPromociones];
    }
  }

  cargarProgramas(patCodigo: any, programaPreseleccionado: any = null) {
    // Encuesta de Programas: 692e3c68b275b4b3bf746eea
    const idEncuestaProgramas = '692e3c68b275b4b3bf746eea';
    
    let filtros = [];
    if (patCodigo) {
        filtros = [{ campo: 'pliPatrocinador_patCodigo', valor: patCodigo }];
    } else if (programaPreseleccionado) {
        // Si no hay patrocinador pero sí programa, filtramos por programa para obtener ESE registro
        // Convertir a número si es posible, ya que progCodigo suele ser numérico
        const progVal = Number(programaPreseleccionado);
        const valorFinal = isNaN(progVal) ? programaPreseleccionado : progVal;
        filtros = [{ campo: 'progCodigo', valor: valorFinal }];
    }

    // Solicitamos campos, incluyendo el enlace al patrocinador
    this.data.ObtenerRegistros(idEncuestaProgramas, ['progCodigo', 'progNombreCorto', 'pliPatrocinador_patCodigo'], 1, 1000, 0, filtros).subscribe({
      next: (res) => {
        if (res.registros) {
          this.programas = res.registros.map((r: any) => ({
            label: r['progNombreCorto'] || 'Programa sin nombre',
            value: r['progCodigo'] || r['_id'],
            patCodigo: r['pliPatrocinador_patCodigo'] // Guardamos patCodigo para uso inverso
          }));

          if (programaPreseleccionado) {
             // Convertir a número si aplica
             const valorNumerico = Number(programaPreseleccionado);
             const valorFinal = isNaN(valorNumerico) ? programaPreseleccionado : valorNumerico;
             this.programaSeleccionado = valorFinal;
             
             // Buscar el programa seleccionado para obtener su patrocinador si no lo tenemos
             const progEncontrado = this.programas.find(p => p.value == valorFinal);
             
             if (progEncontrado && progEncontrado.patCodigo && !this.patrocinadorSeleccionado) {
                // Si encontramos el patrocinador en el programa y no estaba seleccionado, lo seteamos
                const patVal = Number(progEncontrado.patCodigo);
                this.patrocinadorSeleccionado = isNaN(patVal) ? progEncontrado.patCodigo : patVal;
               
               // Al descubrir patrocinador desde programa, cargar la lista de patrocinadores
               // y recargar programas manteniendo la selección de programa.
               this.cargarPatrocinadores(this.patrocinadorSeleccionado, programaPreseleccionado);
               return; // evitamos continuar en este ciclo
             }

             this.onProgramaChange({ value: valorFinal });
          }

          // Si tenemos programa seleccionado, cargar promociones asociadas (para pestaña Formularios)
          if (this.programaSeleccionado) {
            this.cargarPromociones(this.programaSeleccionado);
          }
        }
      },
      error: (err) => console.error('Error cargando programas del patrocinador', err)
    });
  }

  onProgramaChange(event: any) {
    console.log('onProgramaChange', event);
    const valor = event.value;
    if (valor) {
      // Ajuste final según requerimiento explícito: usar 'progCodigo' directo.
      this.filtroPromociones = [{ campo: 'progCodigo', valor: valor }];
      this.filtroPromociones = [...this.filtroPromociones];

      // Cargar promociones para el dropdown cuando estemos en Formularios
      this.cargarPromociones(valor);
    } else {
      this.filtroPromociones = [];
      this.filtroPromociones = [...this.filtroPromociones];
      this.promociones = [];
      this.promocionSeleccionada = null;
    }
  }

  onActiveItemChange(item: MenuItem) {
    this.activeItem = item;
    this.actualizarConfiguracionPestana(item);
  }

  actualizarConfiguracionPestana(item: MenuItem) {
    const config = this.tabs.find(p => p.label === item.label);
    if (config) {
      this.encuestaIdSeleccionada = config.encuestaId;
      this.formularioIdSeleccionado = config.formularioId;
      this.data.setEncuestaSeleccionada(this.encuestaIdSeleccionada);
    }
  }

  esTabActiva(label: string): boolean {
    return this.activeItem?.label === label;
  }

  getFiltros(label: string): any[] {
    const payload = {
      tab: label,
      idFormularioInput: this.tabs.find(t => t.label === label)?.formularioId,
      idEncuestaInput: this.tabs.find(t => t.label === label)?.encuestaId,
      filtrosExternos: undefined as any
    };

    if (label === 'Programas') {
      payload.filtrosExternos = this.filtroProgramas;
      console.log('FormResultados inputs =>', payload);
      return this.filtroProgramas;
    } else if (label === 'Promociones') {
      payload.filtrosExternos = this.filtroPromociones;
      console.log('FormResultados inputs =>', payload);
      return this.filtroPromociones;
    } else if (label === 'Solicitudes') {
      if (this.promocionSeleccionada) {
         // Retorna la promoción seleccionada como filtro
         return [{ campo: 'promocion', valor: this.promocionSeleccionada }];
      }
      return this.filtroVacio;
    }
    // Para Patrocinadores (u otros), devolver siempre la misma referencia vacía
    payload.filtrosExternos = this.filtroVacio;
    console.log('FormResultados inputs =>', payload);
    return this.filtroVacio;
  }

  // --- Promociones para Formularios ---
  cargarPromocionDesdeParametro(promCodigo: string) {
    const valor = this.toNumberIfPossible(promCodigo);
    this.cargarPromociones(null, valor);
  }

  cargarPromociones(progCodigo: any = null, promoPreseleccionado: any = null) {
    const idEncuestaPromociones = '692ececcb899a66ff14b8d66';
    let filtros: any[] = [];

    if (progCodigo) {
      const val = this.toNumberIfPossible(progCodigo);
      filtros = [{ campo: 'progCodigo', valor: val }];
    } else if (promoPreseleccionado) {
      const val = this.toNumberIfPossible(promoPreseleccionado);
      filtros = [{ campo: 'promCodigo', valor: val }];
    }

    this.data.ObtenerRegistros(
      idEncuestaPromociones,
      ['promCodigo', 'promNombre', 'progCodigo'],
      1,
      1000,
      0,
      filtros
    ).subscribe({
      next: (res) => {
        if (res.registros) {
          this.promociones = res.registros.map((r: any) => ({
            label: r['promNombre'] || 'Promoción sin nombre',
            value: r['promCodigo'] || r['_id'],
            progCodigo: r['progCodigo']
          }));

          if (promoPreseleccionado) {
            const valNum = this.toNumberIfPossible(promoPreseleccionado);
            this.promocionSeleccionada = valNum;

            // Si no tenemos programa seleccionado, deducirlo
            const promoEncontrada = this.promociones.find(p => p.value == valNum);
            if (promoEncontrada && promoEncontrada.progCodigo && !this.programaSeleccionado) {
              const progVal = this.toNumberIfPossible(promoEncontrada.progCodigo);
              this.programaSeleccionado = progVal;
              // Deducir patrocinador a través de programas
              this.cargarProgramas(null, progVal);
            }
          }
        }
      },
      error: (err) => console.error('Error cargando promociones', err)
    });
  }

  onPromocionChange(event: any) {
    const valor = this.toNumberIfPossible(event.value);
    this.promocionSeleccionada = valor;
    if (valor) {
      const activeTabLabel = this.activeItem?.label || 'Formularios';
      // Si estamos en la pestaña Solicitudes, nos quedamos ahí; si no, asumimos comportamiento por defecto (Formularios)
      const targetTab = (activeTabLabel === 'Solicitudes') ? 'Solicitudes' : 'Formularios';

      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/pppfa'], {
          queryParams: {
            tab: targetTab,
            promocion: valor
          }
        })
      );
      window.location.href = url;
    }
  }
}
